module.exports = __webpack_public_path__ + "img/pic_elf_02_L.93c8ee56.png";